import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { LocalStorageService } from '../services/common/localstorage-service';
import { inject } from '@angular/core';
import { ToastService } from '../services/common/toast.service';
import { LoaderService } from '../services/common/loader.service';
import { Router } from '@angular/router';
import { catchError, finalize, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localstorageService = inject(LocalStorageService);
  const toastService = inject(ToastService);
  const loaderService = inject(LoaderService);
  const router = inject(Router);

  const token = localstorageService.get('token');
  const excludedUrls = ['/auth/login', '/rvsf/lead/landingPage/save'];
  const shouldExclude = excludedUrls.some((url) => req.url.includes(url));

  let modifiedReq = req;
  if (token && !shouldExclude) {
    modifiedReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  // 🌀 Show loader for every request
  loaderService.show();

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 400: {
          const validationErrors = error.error?.validationErrors;
          if (validationErrors) {
            Object.keys(validationErrors).forEach((key) => {
              toastService.showError(validationErrors[key]);
            });
          } else if (error.error?.message) {
            toastService.showError(error.error.message);
          } else {
            toastService.showError('Invalid request.');
          }
          break;
        }

        case 401: {
          // 🚫 Unauthorized / Invalid session
          toastService.showError('Invalid session. Please log in again.');
          localstorageService.remove('token');
          // Optional: clear any other session data
          localstorageService.clear?.();
          router.navigate(['/login']);
          break;
        }

        case 500:
          toastService.showError(
            'Some error occurred. Please try again later.',
          );
          break;

        case 0:
          toastService.showError('Network error. Check your connection.');
          break;

        default:
          const msg = error.error?.message || 'Unexpected error occurred.';
          toastService.showError(msg);
      }

      return throwError(() => error);
    }),
    finalize(() => {
      loaderService.hide();
    }),
  );
};
